import formatStyle from '@zuzuhapi/formatstyle' 

export default {
  install(Vue) {
    Vue.mixin({
      methods: {
        formatStyle
      }
    })
  }
}
